import { useDispatch } from 'react-redux'

import userApis from 'api/ApiActions/Common/User'
import { useAppSelector } from 'redux/Hook'
import ChangeLocaleComp from 'components/Sidebar/ChangeLocale'
import {
  isFrenchLocale,
  locales,
  setI18nLocale,
} from 'lib/utility/LocaleHelper'
import { fetchUser } from 'redux/thunks/User'

const ChangeLocale = () => {
  const currentUser = useAppSelector((state) => state.user.user)

  const dispatch = useDispatch()

  const handleChangeLocale = async () => {
    const locale = isFrenchLocale() ? locales.english : locales.french

    const params = {
      attributes: {
        'admin-locale': locale,
      },
      id: currentUser.id,
    }

    await userApis.fetchLocaleData(params)

    setI18nLocale(locale)
    dispatch(fetchUser())
  }

  return <ChangeLocaleComp handleChangeLocale={handleChangeLocale} />
}

export default ChangeLocale
